exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.card[data-v-636d26d9] {\n  color: black !important;\n  border: 1px solid rgba(0, 0, 0, 0.125) !important;\n  border-radius: 0.25rem !important;\n}\n.font-15[data-v-636d26d9] {\n  font-size: 15px;\n}\n.height-queue[data-v-636d26d9] {\n  /* height: 205px; */\n}\n", ""]);

// exports
